import React from 'react';
import RadioBlock from "../radio-block/RadioBlock";
import bancoKhipu from "../../../../assets/images/banco-khipu.png";
import PropTypes from 'prop-types';

export const BankKhiku = (props) => {
  const {paymentType, ...other} = props;

  return (
    <RadioBlock
      {...other}
      checked={paymentType === "BankKhipu"}
      className="my-2"
      name="online-payment"
      id="radio-bank-khipu"
      value="BankKhipu"
      label={<span><b>Pago en línea</b> desde tu banco con khipu</span>}
      end={
        <div className="flex-center">
          <img src={bancoKhipu}
               style={{height: 'auto !important'}} alt=""/>
        </div>
      }
    />
  );
};

BankKhiku.propTypes = {
  paymentType: PropTypes.string
}

BankKhiku.defaultProps = {
  paymentType: ""
}

export default BankKhiku;
